import { EventEmitter } from 'events';

const eventEmiter = new EventEmitter();

export default eventEmiter;
